module.exports = __webpack_public_path__ + "img/pager2-quick-icon4.0f565a6d.png";